export enum Currencies {
  'Australian Dollar' = 'AUD',
  'Brazilian Real' = 'BRL',
  'Canadian Dollar' = 'CAD',
  'Euro' = 'EUR',
  'Pound Sterling' = 'GBP',
  'US Dollar' = 'USD',
  'Swiss Franc' = 'CHF',
}
